
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

import { useExtraRatesStore } from '../../model/extra-rates/store'

interface ExtraRatesSaveApiOptions {
  onStart?: () => void
  onSuccess?: () => void
  onError?: (err: unknown) => void
  onFinish?: () => void
}

export const useExtraRatesSaveApi = async (options?: ExtraRatesSaveApiOptions): Promise<boolean> => {
  const { $axios } = useNuxtApp()

  const url = useAdminRoutes('admin.demo-slots.extra-rates')

  if (!url) return false

  const extraRatesStore = useExtraRatesStore()
  const toast = useToast()

  options?.onStart?.()
  extraRatesStore.setSaving(true)

  try {
    await $axios.post(url, { schema: { days_of_week: extraRatesStore.getDaysOfWeek } })

    extraRatesStore.setSaving(false)

    toast.success('Extra rates saved successfully')

    options?.onSuccess?.()

    return true
  } catch (err: unknown) {
    console.error(err)
    extraRatesStore.setSaving(false)
    toast.error('Failed to save extra rates')
    options?.onError?.(err)

    return false
  } finally {
    options?.onFinish?.()
  }
}
